import { Button, Dropdown, MenuProps } from "antd";
import { useState } from "react";
import { ReactComponent as ToolsIcon } from "../../assets/svgs/icons/tools-menu-icon.svg";
import { ReactComponent as ValidationIcon } from "../../assets/svgs/icons/validation-icon.svg";
import { DownOutlined } from "@ant-design/icons";
import { ValidationTable } from "../tables/validation/ValidationTable";

const toolsMenuItems: MenuProps['items'] = [
    {
        label: 'Validation',
        key: '1',
        icon: <ValidationIcon />,
        disabled: true
    },
   
];

const ToolsHeaderMenu = () => {
    const [showValidationTable, setShowValidationTable] = useState(false);

    const handleToolsMenuClick = ({ key }: { key: string }) => {
        switch (key) {
            case '1':
                setShowValidationTable(true);
                break;
            default:
        }
    };
    const toolsMenuProps = {
        items: toolsMenuItems,
        onClick: handleToolsMenuClick,
    };

    return (
        <>
            <Dropdown menu={toolsMenuProps} overlayClassName="menu_dropdown">
                <Button className='menu_button'>
                    <ToolsIcon key="AoisMenuIcon" className='menu_icon' />
                    Tools
                    <DownOutlined />
                </Button>
            </Dropdown>
            <ValidationTable show={showValidationTable} setShowValidationTable={setShowValidationTable}/>
        </>
    )
}
export default ToolsHeaderMenu;